













































import { Component, Inject, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { IUserProviderData } from "@/models/providers/user";

@Component({
  components: {
    "tags-cloud-view": () =>
      import("@/components/app/global/tags/tagsCloudView.vue")
  }
})
export default class UserWellLink extends Mixins(RequestPromises) {
  // Inject
  @Inject({ from: "userProvider" })
  public readonly $userProvider!: () => IUserProviderData;

  // Computed
  public get $userData() {
    return this.$userProvider();
  }

  public get showEmail() {
    const email = this.$_.get(this.$userData, "user.email");
    return email && this.$userData.user.name !== email;
  }

  // Methods
  public copyToClipboard(text) {
    if (!text) return;
    this.$copyText(text).then(() => {
      this.$buefy.toast.open({
        message: this.$t("_.copied_to_clipboard") as string
      });
    });
  }
}
